import { Injectable } from '@angular/core';
import { LoadRequest, TableDataService } from '@vendasta/va-filter2-table';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FacebookFormConfiguration,
  FacebookLeadAdsFormAutomationConfigurationService,
} from './fb-forms-automation-configuration.service';

@Injectable()
export class FacebookFormsTableService implements TableDataService<FacebookFormConfiguration> {
  facebookFormsTableData$: Observable<FacebookFormConfiguration[]>;
  showAlert$: Observable<boolean>;
  totalResults$: Observable<number>;

  constructor(private dataService: FacebookLeadAdsFormAutomationConfigurationService) {
    this.showAlert$ = this.dataService.tableShowAlert$;
    this.facebookFormsTableData$ = this.dataService.facebookFormsTableData$;
    this.totalResults$ = this.facebookFormsTableData$.pipe(map((forms) => forms.length));
  }

  load(_request: LoadRequest): Observable<FacebookFormConfiguration[]> {
    return this.facebookFormsTableData$;
  }
}
